import { ReactNode, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { UserRole } from "../types/Roles";
import { ROLE } from "../shared/constants";

interface WithRoleGuardProps {
  children: ReactNode;
  role: UserRole;
  allowedRoles: UserRole[];
  redirectPath?: string;
  fallbackComponent?: ReactNode;
}

export const withRoleGuard = ({
  children,
  role,
  allowedRoles,
  redirectPath,
  fallbackComponent,
}: WithRoleGuardProps): ReactElement | null => {
  // Role is still being determined — don't redirect yet.
  if (role === ROLE.UNKNOWN) return null;
  if (!allowedRoles.includes(role)) {
    if (redirectPath) {
      return <Navigate to={redirectPath} />;
    }
    return (fallbackComponent as ReactElement) ?? null;
  }
  return <>{children}</>;
};
